// src/metaPixel.js


export const trackAddToCart = (product) => {
  if (!window.fbq) return;
  window.fbq('track', 'AddToCart', {
    content_ids: [product.id],
    content_name: product.name,
    content_type: 'product',
    value: product.price,
    currency: 'AED',
  });
  console.log('Meta Pixel AddToCart event sent for:', product.name);
};

export const trackPurchase = (order) => {
  if (!window.fbq) return;
  window.fbq('track', 'Purchase', {
    content_ids: order.productIds,
    content_name: order.productNames.join(', '),
    content_type: 'product',
    value: order.total,
    currency: 'AED',
  });
  console.log('Meta Pixel Purchase event sent for order:', order);
};


// google analytics event tracking
export const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window !== 'undefined' && window.gtag) {
      
      window.gtag('event', eventName, eventParams);
    }
  };
